import {
  SIGN_UP_ACTION_INIT,
  SIGN_UP_ACTION_SUCCESS,
  SIGN_UP_ACTION_FAILED,
  IS_COMPANY_NAME_EXIST_INIT,
  IS_COMPANY_NAME_EXIST_SUCCESS,
  IS_COMPANY_NAME_EXIST_FAILED,
  EMAIL_EXIST_INIT,
  EMAIL_EXIST_SUCCESS,
  EMAIL_EXIST_FAILED,
  GET_INVESTOR_TYPE_INIT,
  GET_INVESTOR_TYPE_SUCCESS,
  GET_INVESTOR_TYPE_FAILED,
  // GET_STRATEGY,
  GET_STRATEGY_INIT,
  GET_STRATEGY_SUCCESS,
  GET_STRATEGY_FAILED,
  IS_COOPRATIVE_EMAIL_INIT,
  IS_COOPRATIVE_EMAIL_SUCCESS,
  IS_COOPRATIVE_EMAIL_FAILED,
  GET_FUND_TYPE_INIT,
  GET_FUND_TYPE_SUCCESS,
  GET_FUND_TYPE_FAILED,
} from "./constants";
const initialState = {
  loading: false,
  isCompanyNameExist: null,
  isCompanyCooperativeEmail:null,
  isEmailExist: null,
  investorType: [],
  signUpSuccess: false,
  stratagies: [],
  fundTypes: []
};

export default function signup(state = initialState, action) {
  switch (action.type) {
    case SIGN_UP_ACTION_INIT:
      return { ...state, loading: true, signUpSuccess: false };
    case SIGN_UP_ACTION_SUCCESS:
      return { ...state, loading: false, signUpSuccess: true };
    case SIGN_UP_ACTION_FAILED:
      return { ...state, loading: false };
    case IS_COMPANY_NAME_EXIST_INIT:
      return { ...state };
    case IS_COMPANY_NAME_EXIST_SUCCESS:
      return { ...state, isCompanyNameExist: action.payload };
    case IS_COMPANY_NAME_EXIST_FAILED:
      return { ...state };
    case EMAIL_EXIST_INIT:
      return { ...state };
    case EMAIL_EXIST_SUCCESS:
      return { ...state, isEmailExist: action.payload };
    case EMAIL_EXIST_FAILED:
      return { ...state };
    case GET_INVESTOR_TYPE_INIT:
      return { ...state, loading: true };
    case GET_INVESTOR_TYPE_SUCCESS:
      return { ...state, loading: false, investorType: action.payload };
    case GET_INVESTOR_TYPE_FAILED:
      return { ...state, loading: false };
    case GET_STRATEGY_INIT:
      return { ...state, loading: true };
    case GET_STRATEGY_SUCCESS:
      return { ...state, loading: false, stratagies: action.payload };
    case GET_STRATEGY_FAILED:
      return { ...state, loading: false };
    case IS_COOPRATIVE_EMAIL_INIT:
      return { ...state };
    case IS_COOPRATIVE_EMAIL_SUCCESS:
      return { ...state, isCompanyCooperativeEmail: action.payload };
    case IS_COOPRATIVE_EMAIL_FAILED:
      return { ...state };
    case GET_FUND_TYPE_INIT:
      return {...state, loading: true};
    case GET_FUND_TYPE_SUCCESS:
      return {...state, loading: false, fundTypes: action.payload};
    case GET_FUND_TYPE_FAILED:
      return { ...state, loading: false}
    default:
      return state;
  }
}
